// Der Pfad ueber einer Seitenueberschrift (APG Breadcrumb; v4 crumbs).
//
// Ein `<nav>` namens "Pfad" mit einer geordneten Liste: die Schritte davor sind
// Links, der letzte ist die Seite selbst (`aria-current="page"`, kein Link).
// Das Trennzeichen ist Zierde und wird nicht vorgelesen. Lange Namen brechen um
// statt die Seite zu verbreitern (WCAG 1.4.10).

import type { ReactElement } from 'react';
import { makeStyles, tokens } from '@fluentui/react-components';

import { AppLink } from './router.tsx';

const useStyles = makeStyles({
  pfad: { fontSize: tokens.fontSizeBase200, lineHeight: tokens.lineHeightBase200, color: tokens.colorNeutralForeground3, minWidth: 0 },
  // Bricht der Pfad um, haelt der Zeilenabstand 8 px: 16 px Zeile plus 8 px
  // ergeben 24 px zwischen den Mittelpunkten der Links (WCAG 2.5.8, Abstand).
  // Einzeilig bleibt die Hoehe, die der erste Bildschirm misst. Mindestens 8 px
  // auch bei kleiner Wurzelschrift: die Zeilenhoehe der Fluent-Tokens steht in
  // px und schrumpft nicht mit, 0,5 rem allein faenden dann unter 24 px.
  liste: { listStyle: 'none', margin: 0, padding: 0, display: 'flex', flexWrap: 'wrap', gap: 'max(8px, 0.5rem)' },
  schritt: {
    // Alternativtext leer: das Trennzeichen wird nicht vorgelesen.
    '::after': { content: '"/" / ""', marginInlineStart: '0.5rem', color: tokens.colorNeutralForeground3 },
  },
  hier: { color: tokens.colorNeutralForeground2, overflowWrap: 'anywhere' },
});

export interface PfadSchritt {
  readonly label: string;
  readonly to: string;
}

export function Brotkrume({ schritte, hier }: { readonly schritte: readonly PfadSchritt[]; readonly hier: string }): ReactElement {
  const own = useStyles();
  return (
    <nav aria-label="Pfad" className={own.pfad}>
      <ol className={own.liste}>
        {schritte.map((schritt) => (
          <li key={schritt.to} className={own.schritt}>
            <AppLink to={schritt.to}>{schritt.label}</AppLink>
          </li>
        ))}
        <li className={own.hier} aria-current="page">
          {hier}
        </li>
      </ol>
    </nav>
  );
}
